export default {
  outList: [
    {
      light_point_1:[
        {
          title: '智感安心',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '全球NCAP五星安全标准，80%以上高强度钢结构，三条碰撞吸能路径，前保双横梁双吸能盒设计'
        }
      ],
      light_point_2:[
        {
          title: '全优凌波美学',
          type: 'image',
          video: '',
          image: 'lightPoint/2/14.jpg',
          text: '凌波流动溜背造型+流转撞色悬浮车顶'
        }
      ],
      light_point_3:[
        {
          title: '全优凌波美学',
          type: 'image',
          video: '',
          image: 'lightPoint/2/15.jpg',
          text: '18寸凌动流星铝合金轮毂'
        }
      ],
      light_point_4:[
        {
          title: '全优凌波美学',
          type: 'image',
          video: '',
          image: 'lightPoint/2/12.jpg',
          text: '凌波钻切前格栅'
        }
      ],
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '智感安心',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '360°高清全景影像'
        }
      ],
      light_point_2:[
        {
          title: '全优流水内饰',
          type: 'image',
          video: '',
          image: 'lightPoint/2/16.jpg',
          text: '凌动悦享多功能方向盘+游艇式电子档把'
        }
      ],
      light_point_3:[
        {
          title: '全优流水内饰',
          type: 'image',
          video: '',
          image: 'lightPoint/2/18.jpg',
          text: '大尺寸悬浮储物设计'
        }
      ],
      light_point_4:[
        {
          title: '智感舒享',
          type: 'image',
          video: '',
          image: 'lightPoint/1/8.jpg',
          text: '无极炫彩氛围灯'
        }
      ],
      light_point_5:[
        {
          title: '智感舒享',
          type: 'image',
          video: '',
          image: 'lightPoint/1/7.jpg',
          text: 'SONY品牌音响'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '智感安心',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '全球NCAP五星安全标准，80%以上高强度钢结构，三条碰撞吸能路径，前保双横梁双吸能盒设计'
    },
    {
      title: '智感安心',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '10安全气囊'
    },
    {
      title: '智感安心',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: 'L2.5级智能驾驶辅助功能'
    },
    {
      title: '智感安心',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '360°高清全景影像'
    },
    {
      title: '智感私教',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '行业首创 AI智教，科大讯飞近8000种听播资源'
    },
    {
      title: '智感舒享',
      type: 'image',
      video: '',
      image: 'lightPoint/1/6.jpg',
      text: '超大全景天窗'
    },
    {
      title: '智感舒享',
      type: 'image',
      video: '',
      image: 'lightPoint/1/7.jpg',
      text: 'SONY品牌音响'
    },
    {
      title: '智感舒享',
      type: 'image',
      video: '',
      image: 'lightPoint/1/8.jpg',
      text: '无极炫彩氛围灯'
    },
    {
      title: '智感互联',
      type: 'image',
      video: '',
      image: 'lightPoint/1/9.jpg',
      text: '24.6吋悬浮式双联屏+Lion5.0 AI科技智慧座舱'
    }
  ],
  tab2: [
    {
      title: '全优凌波美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/11.jpg',
      text: '凌波动感豪华宽体车身'
    },
    {
      title: '全优凌波美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/12.jpg',
      text: '凌波钻切前格栅'
    },
    {
      title: '全优凌波美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/13.jpg',
      text: '超宽适越级空间（2790mm轴距）'
    },
    {
      title: '全优凌波美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/14.jpg',
      text: '凌波流动溜背造型+流转撞色悬浮车顶'
    },{
      title: '全优凌波美学',
      type: 'image',
      video: '',
      image: 'lightPoint/2/15.jpg',
      text: '18寸凌动流星铝合金轮毂'
    },{
      title: '全优流水内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/16.jpg',
      text: '凌动悦享多功能方向盘+游艇式电子档把'
    },{
      title: '全优流水内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/17.jpg',
      text: '炫彩氛围背光面板，一鹿有你，一路相伴'
    },{
      title: '全优流水内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/18.jpg',
      text: '大尺寸悬浮储物设计'
    },{
      title: '全优流水内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/19.jpg',
      text: '仪表台贯穿式出风口+副驾置物挂钩'
    },{
      title: '全优流水内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/2/20.jpg',
      text: '后排头等舱睡眠枕头'
    },
  ],
  tab3: [
    {
      title: '鲲鹏动力',
      type: 'image',
      video: '',
      image: 'lightPoint/3/21.jpg',
      text: '1.6TGDI+高效机能7速湿式双离合变速'
    },
    {
      title: '标配EPS+EPB+AUTOHOLD',
      type: 'image',
      video: '',
      image: 'lightPoint/3/22.jpg',
      text: '2种转向模式+3种驾驶模式'
    },
    {
      title: '国际大师级驾驭感调教',
      type: 'image',
      video: '',
      image: 'lightPoint/3/23.jpg',
      text: ''
    }
  ],
}
